var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"item-layout",on:{"click":function($event){return _vm.$emit('item-click', _vm.item)}}},[_c('b-icon',{attrs:{"icon":_vm.item.icon}}),_c('h4',{staticClass:"body-text item-layout__text"},[_vm._v(_vm._s(_vm.item.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }